import { Component, ElementRef, Input, ViewChild } from '@angular/core';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'calsoft-videocontentwithcard',
  templateUrl: './videocontentwithcard.component.html',
  styleUrls: ['./videocontentwithcard.component.scss']
})
export class VideocontentwithcardComponent {


    public serverPath = environment.commonImageApi + '/home/';
  
    @Input() img: any;
  
    @Input() item: any;
  
    @Input() index: any;

    hovered = false;
  

    @ViewChild('videoPlayer', { static: true }) videoPlayer!: ElementRef<HTMLVideoElement>;

    ngOnInit(): void {
      setTimeout(() => {
        if (this.videoPlayer && this.videoPlayer.nativeElement) {
          const video = this.videoPlayer.nativeElement;
          video.muted = true; // Ensure it's muted for autoplay
          video.play().catch(err => {
            console.warn('Autoplay failed:', err);
          });
        }
      }, 0); // Delay to make sure view is rendered
    }
    

    togglePlay(video: HTMLVideoElement): void {
      if (video.paused) {
        video.play();
      } else {
        video.pause();
      }
    }
  }    





